export type StatusIndicator = 'none' | 'minor' | 'major' | 'critical';

export enum ClaudeStatus {
    UNKNOWN = 'unknown',
    OPERATIONAL = 'operational',
    DEGRADED = 'degraded',
    PARTIAL_OUTAGE = 'partial_outage',
    MAJOR_OUTAGE = 'major_outage',
    MAINTENANCE = 'maintenance'
}

export type ComponentStatus =
    | 'operational'
    | 'degraded_performance'
    | 'partial_outage'
    | 'major_outage'
    | 'under_maintenance';

export interface StatusComponent {
    id: string;
    status: ComponentStatus;
}

export interface ComponentsResponse {
    components: StatusComponent[];
}
